import {ITCIApplication, TCIApplicationDeploymentType, TCITenantAppType} from "../tci/tci-application";
import {TCI_APP_DEPLOYMENT_STAGE, TCILiveappsStatus} from "../tci/tci-app-deploy";

export interface ILAApplication {
    id: string;
    name: string;
    description: string;
    inProgressStartTime?: number;
    lastRunTime?: number;
    nextRunTime?: number;
    isDisabled?: boolean;
    owner: string;
    creationDate: number;
    modificationDate: number;
    latestVersion: number;
    latestClientValidationState: string;
    latestServerValidationState: string;
    latestValidationState: string;
    latestGovernanceState: string;
    adminState: string;
    adminStateVersionId: string;
    latestVersionId: string;
    lastModifiedBy: string;
    lastFinalized: string;
    lastPublished: string;
    lastWithdrawn: string;
    inBin: boolean;
}

export function mapILAApplicationToTenantAppType(data: ILAApplication): ITCIApplication {
    return {
        id: data.id,
        name: data.name,
        description: data.description,
        type: TCITenantAppType.liveapps,
        orgId: null,
        userId: null,
        publishStage: TCI_APP_DEPLOYMENT_STAGE.DRAFT as any,
        createdTime: data.creationDate || 0,
        modifiedTime: data.modificationDate || 0,
        lastRunTime: data.lastRunTime || 0,
        sandboxId: null,
        info: {
            end_points: null,
            num_instances: 0,
            tenantSubType: null,
            tenantStatus: TCILiveappsStatus.mapILAApplicationStatusToDeploymentStatus(data.latestGovernanceState),
            isMetricsEnabled: true,
            externalId: data.latestVersionId,
            externalUrl: `/api/v1/liveappsui/apps/dt-app/index.html#/application-content/${data.latestVersionId}?mode=TCI`
        },
        ownerName: data.owner,
        owner: null,
        createdByName: null,
        appInitialStatus: TCILiveappsStatus.mapILAApplicationStatusToDeploymentStatus(data.latestGovernanceState),
        onPremise: false,
        appDeploymentType: TCIApplicationDeploymentType.CLOUD.getString(),
    };
}

/**
 * interface ILAUserClaimKVPair
 */
export interface ILAUserClaimKVPair {
    [id: string]: string;
}

/**
 * interface ILAUserClaims
 */
export interface ILAUserClaims {
    u?: number;
    i?: number;
    s?: ILAUserClaimKVPair;
    g?: ILAUserClaimKVPair;
    p?: number[];
    n?: string;
    a?: boolean;
}

/**
 * interface ILAAuthorize
 */
export interface ILAAuthorize {
    bpm: ILAUserClaims;
}
